export default {
  tbody: {
    boxShadow: 'none',
  },
};
